<template>
<div id="analypercent">
  <b-field class="markdown-body">
    <help-analy-percent />
  </b-field>
  <b-field  horizontal label="渠道">
    <channel-selector2 ref="channelSelector" @change="onChannelChange"/>
  </b-field>
  <b-field horizontal label="日期范围">
    <b-datepicker
      placeholder="选择日期范围"
      v-model="rangeDates"
      :min-date="minDate"
      :max-date="maxDate"
      :loading="isLoading"
      icon="calendar-today"
      range >
    </b-datepicker>
  </b-field>
  <b-field horizontal label="比例（%）">
    <b-numberinput v-model="rate" step="1" max="100" min="1" />
  </b-field>
  <b-field position="is-centered" grouped>
    <button class="button is-danger" :disabled="!canBuild" @click="onBuild">生成数据</button>
  </b-field>
  <b-field>
    <textarea v-if="buildNote" class="textarea" rows="13" v-model="buildNote" />
  </b-field>
</div>
</template>

<script>
// 扣量设置
import ChannelSelector2 from '@/components/channel/ChannelSelector2'
import cache from '@/core/cache'
import { fromNow } from '@/core/util'

import HelpAnalyPercent from '@/help/analypercent.md'

export default {
  components: { ChannelSelector2, HelpAnalyPercent },
  computed: {
    canBuild () {
      return true
    }
  },
  methods: {
    onChannelChange (channels) {
      this.channels = channels
    },
    async onBuild () {
      this.buildNote = null
      const r = cache.getR(true)
      if (r <= 0) {
        this.hub.alert('请选择一个大于 0 的 Regional。')
        return
      }
      const data = {
        gids: [r],
        rate: this.rate * 0.01,
        from_date: this.formatDate(this.rangeDates[0]),
        to_date: this.formatDate(this.rangeDates[1])
      }
      if (this.channels && this.channels.length > 0) {
        data.channels = this.channels
      }
      try {
        const rdata = await this.mjp.post2({
          url: '/audible/percent/',
          data,
          mjpType: 'admin'
        })
        const note = `按统计比例更新数据

日期： ${data.from_date} 到 ${data.to_date}
比例： ${data.rate}
提供的游戏：${rdata.gids}
支持的游戏：${rdata.filtered_gids}
提供的渠道：${rdata.channels}
支持的渠道：${rdata.filtered_channels}
插入注册条数： ${rdata.register_inserted}
更新注册条数： ${rdata.register_updated}
插入活跃条数： ${rdata.active_inserted}
更新活跃条数： ${rdata.active_updated}`
        this.buildNote = note
      } catch (e) {
        this.buildNote = String(e)
      }
    }
  },
  data () {
    return {
      minDate: new Date(2018, 4, 12),
      maxDate: new Date(),
      rangeDates: [fromNow({ days: -7 }), new Date()],
      isLoading: false,
      rate: 50,
      channels: null,
      buildNote: null
    }
  }
}
</script>

<style>
</style>
